// src/DragHandle.ts
import {
  defaultComputePositionConfig,
  DragHandlePlugin,
  dragHandlePluginDefaultKey
} from "@tiptap/extension-drag-handle";

// src/Vue.ts
import VueDefault from "vue";
var Vue = VueDefault;

// src/DragHandle.ts
var DragHandle = Vue.extend({
  name: "DragHandleVue",
  props: {
    pluginKey: {
      type: [String, Object],
      default: () => dragHandlePluginDefaultKey
    },
    editor: {
      type: Object,
      required: true
    },
    computePositionConfig: {
      type: Object,
      default: () => ({})
    },
    onNodeChange: {
      type: Function,
      default: null
    },
    onElementDragStart: {
      type: Function,
      default: null
    },
    onElementDragEnd: {
      type: Function,
      default: null
    },
    class: {
      type: String,
      default: "drag-handle"
    }
  },
  mounted() {
    const { editor, pluginKey, onNodeChange, onElementDragStart, onElementDragEnd } = this.$props;
    editor.registerPlugin(
      DragHandlePlugin({
        editor,
        element: this.$el,
        pluginKey,
        computePositionConfig: { ...defaultComputePositionConfig, ...this.computePositionConfig },
        onNodeChange,
        onElementDragStart,
        onElementDragEnd
      }).plugin
    );
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    const { pluginKey, editor } = this.$props;
    editor.unregisterPlugin(pluginKey);
  },
  render(h) {
    return h(
      "div",
      {
        class: this.class,
        attrs: {
          "data-dragging": "false"
        }
      },
      this.$slots.default
    );
  }
});

// src/index.ts
var index_default = DragHandle;
export {
  DragHandle,
  index_default as default
};
//# sourceMappingURL=index.js.map